import { useState, useContext, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { LangCtx, PayLoadCtx } from "../../lib/context";
import { getSubdomain } from "../../lib/domain";
import { currencyRates } from "../../lib/ReduxStore";
import "./UserMenuPopover.css";

const UserMenuPopover = ({ handleLogout }) => {
    const [isOpen, setIsOpen] = useState(false);
    const popoverRef = useRef(null);
    const location = useLocation();
    const dispatch = useDispatch();
    const { l } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);
    const _domain = getSubdomain(window.location.hostname);

    const role = payload?.consultRole;
    const isPatient = role === "patient" || role === "P";
    const isOnDashboard = location.pathname === "/patient-dashboard";

    const getProfileRoute = () => {
        switch (role) {
            case "doctor":
                return "/doctor-profile";
            case "clinic":
                return "/edit-profile";
            case "admin":
                return "/admin-settings";
            default:
                return "/patient-profile";
        }
    };

    const getSettingsRoute = () => {
        switch (role) {
            case "doctor":
                return "/doctor-settings";
            case "clinic":
                return "/clinic-settings";
            case "admin":
                return "/admin-settings";
            default:
                return "/patient-settings";
        }
    };

    const togglePopover = () => setIsOpen(!isOpen);
    const closePopover = () => setIsOpen(false);

    const handleLogoutClick = () => {
        dispatch(currencyRates());
        if (handleLogout) handleLogout();
        closePopover();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popoverRef.current && !popoverRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const hasCustomImage = payload?.profileImage?.url && payload.profileImage.url !== process.env.REACT_APP_defaultProfileImage;
    const showLicense = role === "clinic";

    return (
        <div className="userMenuPopover" ref={popoverRef}>
            <div className="avtrCircle clickable" onClick={togglePopover} role="button" tabIndex={0} aria-label="User menu">
                <img
                    src={hasCustomImage ? payload.profileImage.url : "/images/icons/profile-outline.png"}
                    className={hasCustomImage ? "" : "invertWhite"}
                    alt="profile"
                />
            </div>
            {isOpen && (
                <div className="popoverContent">
                    <ul className="popoverMenu">
                        {/* Dashboard - show for patients only when not on dashboard */}
                        {isPatient && !isOnDashboard && (
                            <li className="popoverItem">
                                <Link to="/patient-dashboard" onClick={closePopover} className="popoverLink">
                                    <svg className="popoverIconSvg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <rect x="3" y="3" width="7" height="7" rx="1" />
                                        <rect x="14" y="3" width="7" height="7" rx="1" />
                                        <rect x="3" y="14" width="7" height="7" rx="1" />
                                        <rect x="14" y="14" width="7" height="7" rx="1" />
                                    </svg>
                                    <span>{l.dashboard || "Dashboard"}</span>
                                </Link>
                            </li>
                        )}
                        <li className="popoverItem">
                            <Link
                                to={getProfileRoute()}
                                onClick={closePopover}
                                className={location.pathname === getProfileRoute() ? "popoverLink activePopoverLink" : "popoverLink"}
                            >
                                <img src="/images/icons/profile-outline.png" className="popoverIcon" alt="icon" />
                                <span>{l.my_profile}</span>
                            </Link>
                        </li>
                        <li className="popoverItem">
                            <Link
                                to={getSettingsRoute()}
                                onClick={closePopover}
                                className={location.pathname === getSettingsRoute() ? "popoverLink activePopoverLink" : "popoverLink"}
                            >
                                <img src="/images/icons/settings-outline.png" className="popoverIcon" alt="icon" />
                                <span>{isPatient ? l.change_pwd || "Change Password" : l.settings}</span>
                            </Link>
                        </li>
                        {showLicense && (
                            <li className="popoverItem">
                                <Link
                                    to="/clinic-license"
                                    onClick={closePopover}
                                    className={location.pathname === "/clinic-license" ? "popoverLink activePopoverLink" : "popoverLink"}
                                >
                                    <img src="/images/icons/license-Management.png" className="popoverIcon" alt="icon" />
                                    <span>{l.licenses}</span>
                                </Link>
                            </li>
                        )}
                        {isPatient && (
                            <li className="popoverItem">
                                <Link
                                    to="/patient-uploads"
                                    onClick={closePopover}
                                    className={location.pathname === "/patient-uploads" ? "popoverLink activePopoverLink" : "popoverLink"}
                                >
                                    <img src="/images/icons/uploads-outline.png" className="popoverIcon" alt="icon" />
                                    <span>{l.my_uploads || "My Reports"}</span>
                                </Link>
                            </li>
                        )}
                        {_domain?.subdomain === process.env.REACT_APP_defaultdomian && (
                            <li className="popoverItem">
                                {/* <a
                                    className="popoverLink"
                                    href="https://help.instavc.com/inclinic"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={closePopover}
                                >
                                    <img src="/images/icons/play-button.png" className="popoverIcon" alt="icon" />
                                    <span>{l.help_center}</span>
                                </a> */}
                            </li>
                        )}
                        <li className="popoverItem popoverDivider">
                            <div className="popoverLink" onClick={handleLogoutClick}>
                                <img src="/images/icons/logout-outline.png" className="popoverIcon" alt="icon" />
                                <span>{l.logout}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default UserMenuPopover;
